import axios from 'axios';

export default {
  async index() {
    const { data } = await axios.get(`${window.addiesaas.config.apiUri}/products/product?type=playcard_sale`);
    return data.products;
  },

  async get(id) {
    const { data } = await axios.get(`${window.addiesaas.config.apiUri}/products/product/${id}`);
    return data;
  }
}
